import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-btn-exportar-excel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './btn-exportar-excel.component.html',
  styleUrls: ['./btn-exportar-excel.component.scss'],
})
export class BtnExportarExcelComponent {
  /**
   * Controla se o botão está desabilitado de verdade (bloqueia o clique
   * nativamente — para regras de acesso, onde não faz sentido reagir ao
   * clique de forma alguma).
   */
  @Input() disabled: boolean = false;
  /**
   * Deixa o botão com aparência "apagada" sem bloquear o clique — usado
   * quando o clique deve continuar chegando no pai para que ele avise o
   * usuário (ex: "selecione uma obra"), em vez de travar silenciosamente.
   */
  @Input() esmaecido: boolean = false;
  @Input() label: string = '';
  @Input() icon: string = '';
  @Output() exportar = new EventEmitter<void>();

  onClick() {
    if (!this.disabled) {
      this.exportar.emit();
    }
  }
}
